(function($) {

    function getLocale() {
        var links = window.location.href.split('/');
        var hcIndex = links.indexOf('hc');
        var links2 = links[hcIndex + 1].split('?');
        var locale = links2[0];

        return locale;
    }

    function setFormSubjectStartup() {
        const subjects = {
            'startups_discount': '20% startup discount',
            'unlimited_customization': 'Unlimited customization request',
            'header_footer': 'Header/Footer customization request',
            'get_free': 'Theme + free extension',
            'starter': 'Starter Customization (2 months)',
            'extensions_bundle': 'Replace extensions in the bundle',
            'black_friday': 'Black Friday Marketplace',
            'black_friday_banner': 'Black Friday site',
            'buy_all_themes': 'Buy All Themes for $995',
        }
        const subjectParam = getUrlParameter('subject');

        if (!subjectParam) return;

        $('#subject').attr('value', subjects[subjectParam]);

    }
    setFormSubjectStartup();


    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }


    $("[data-returl]").val(
        window.location.origin + "/pages/contact-us/hc/?case_submitted=true"
    );

    $("[data-suborigin]").val(window.location.hostname);

    if (getUrlParameter("case_submitted")) {
        $("[data-ltds-notification]").removeAttr("hidden");
        $("[data-role=contact-form]").hide();
    }

    $(document).on("click", "[data-ltds-notification-dismiss]", function(e) {
        e.preventDefault();
        $(this)
            .parents('[data-ltds-notification]')
            .remove();
    });

    var constraints = {
        email: {
            presence: true,
            email: true
        },
        name: {
            presence: true
        },
        subject: {
            presence: true
        },
        description: {
            presence: true
        }
    };

    const form = document.querySelector("[data-validate-form]");
    if (form) {
        const roistatField = form.querySelector("[data-roistat]");

        form.addEventListener("submit", function(ev) {
            roistatField.value = getCookie('roistat_visit');
            const contactEmailValue = $('input[name="email"]').val();
            analytics.identify(null, { email: contactEmailValue });
            analytics.track('ContactUs');
            var errors = validate(form, constraints);
            if (errors || grecaptcha.getResponse() == "") {
                ev.preventDefault();
                showErrors(form, errors || {});
            }
        });

        var inputs = document.querySelectorAll("input, textarea, select");
        for (var i = 0; i < inputs.length; ++i) {
            inputs.item(i).addEventListener("change", function(ev) {
                var errors = validate(form, constraints) || {};
                showErrorsForInput(this, errors[this.name]);
            });
        }

        function showErrors(form, errors) {
            $(form)
                .find("input[name], select[name], textarea")
                .each(function(index, input) {
                    showErrorsForInput(input, errors && errors[input.name]);
                });
        }

        function showErrorsForInput(input, errors) {
            var formGroup = $(input).parents("[data-form-field]");
            var messages = formGroup.find("[data-ltds-messages]");
            resetFormGroup(formGroup);
            if (errors) {
                formGroup.addClass("has-error").addClass("error-group");
                $.each(errors, function(index, error) {
                    addError(messages, error);
                });
            } else {
                formGroup.addClass("has-success");
            }
        }

        function resetFormGroup(formGroup) {
            formGroup
                .removeClass("has-error")
                .removeClass("has-success")
                .removeClass("error-group");
            formGroup.find(".notification.notification-error").each(function() {
                $(this).remove();
            });
        }

        function addError(messages, error) {
            var block = document.createElement("div");
            block.classList.add("notification");
            block.classList.add("notification-error");
            block.classList.add("notification-inline");
            block.innerText = error;
            messages.append(block);
        }
    }

    $(".subject-value").click(function() {
        var text = $(this).val();
        $("#subject").val(text);
    });

    function checkedValue() {
        var subjectVal = ($("#subject").val().toLowerCase());
        var inputEmpty = $("[data-input-empty]");
        $('.subject-value-compare').each(function() {
            if ($(this).val().toLowerCase() == subjectVal) {
                ($(this).prop('checked', true));
                return false;

            } else if (subjectVal == "") {
                inputEmpty.prop('checked', false)

            } else {
                inputEmpty.prop('checked', true)
            }
        });
    }
    checkedValue()
    $("#subject").keyup(function() {
        if ($(this).val() == "") {
            $('.subject-value-compare').prop('checked', false)
        } else {
            checkedValue();
        }
    });
})(jQuery);